export const TOO_MANY_REQUESTS_DEFAULT_MESSAGE = 'Oops! You’re sending requests too quickly. Please wait a moment before trying again.';
export const REACHED_MAX_ATTEMPTS = 'reached_max_attempts';